import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Text from '../Text/Text'
import checkImg from './check.svg'
import styles from './checkboxSquareField.module.scss'

const CheckboxSquareField = (props) => {
  const {
    initialCheck,
    reinitializeControl,
    field: { name = '', id: fieldId, value } = {},
    form: { touched = {}, errors = {}, setFieldValue } = {},
    label,
    full,
    transform,
    onChange
  } = props

  const [checked, setChecked] = useState(!!initialCheck)

  useEffect(() => {
    setChecked(!!initialCheck)
  }, [reinitializeControl, initialCheck])

  const checkboxSquareField = classNames(styles.field, {
    [styles.full]: full
  })

  const checkboxClass = classNames(styles.check, {
    [styles.checked]: checked
  })

  const handleChange = () => {
    const newChecked = !checked

    setChecked(newChecked)

    const newValue = transform ? transform(value, newChecked) : !value

    if (onChange) onChange(newValue)

    return setFieldValue && setFieldValue(name, newValue)
  }

  return (
    <div className={checkboxSquareField}>
      <label htmlFor={fieldId}>
        <div className={checkboxClass}>
          <img src={checkImg} alt="Checked" />
        </div>

        <input
          type="checkbox"
          id={fieldId}
          name={name}
          onChange={handleChange}
          checked={checked}
          className={styles.input}
        />

        <Text size="xxxs" color="gray" value={label} />
      </label>

      {touched[name] && errors[name] && (
        <div className="error">{errors[name]}</div>
      )}
    </div>
  )
}

CheckboxSquareField.defaultProps = {
  field: undefined,
  form: undefined,
  label: null,
  full: false,
  transform: null,
  initialCheck: null,
  reinitializeControl: null,
  onChange: null
}

CheckboxSquareField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.number
    ])
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func
  }),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node
  ]),
  full: PropTypes.bool,
  transform: PropTypes.func,
  initialCheck: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number
  ]),
  reinitializeControl: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number])
    )
  ]),
  onChange: PropTypes.func
}

export default CheckboxSquareField
